export const GET_PRICING = 'GET_PRICING';
export const GET_LIST_WRITERS = 'GET_LIST_WRITERS';
export const GET_REFERENCE_ORDERS = 'GET_REFERENCE_ORDERS';
export const GET_LIST_NOTIFICATIONS = 'GET_LIST_NOTIFICATIONS';
export const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS';
